import SalaryAnalyzerBanner from './SalaryAnalyzerBanner'
export default SalaryAnalyzerBanner
